import React from 'react'
import { tdah_questions } from '../../../../escalas/tdah/tdah.catalog'

// Example of "sars": [0,1,2,3,4,0,1,2,3,4,0,1,2,3,4,0,1,2]

// Response options: [Nunca, Raramente, A veces, Frecuentemente, Muy frecuentemente]

const resps = ["Nunca", "Raramente", "A veces", "Frecuentemente", "Muy frecuentemente"]

export default function SarsResults({sars}) {
  if (!sars) return null

  const score = sars.reduce((a, v) => a + v, 0)

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score} / 72</strong></td>
      </tr>
      {tdah_questions.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{resps[sars[i]]}</td>
        </tr>
      ))}
    </div>
  )
}
